import { Run } from "types/generated";

import {
  COLUMN_ORDER_APPROVAL,
  COLUMN_ORDER_APPROVAL_ANSIBLE,
  COLUMN_ORDER_USER,
  COLUMN_ORDER_USER_ANSIBLE,
} from "./constants";

export type RunsListPerCommit = Array<{
  hash: string;
  group: Run[];
  selectable: boolean;
  index: number;
}>;

export const getGroupKey = (hash: string, index: number): string => {
  return `${hash}_${index}`;
};

export const getSelectableRunIds = (
  runsListPerCommit: RunsListPerCommit,
  filter?: (run: Run) => boolean
): Set<string> => {
  const selectedIds = new Set<string>();

  for (const { selectable, group } of runsListPerCommit) {
    if (!selectable) continue;

    for (const run of group) {
      if (!filter || filter(run)) {
        selectedIds.add(run.id);
      }
    }
  }

  return selectedIds;
};

export const getRunsColumnOrder = (selectable?: boolean, isAnsible?: boolean): string => {
  if (selectable) {
    return isAnsible ? COLUMN_ORDER_APPROVAL_ANSIBLE : COLUMN_ORDER_APPROVAL;
  }

  return isAnsible ? COLUMN_ORDER_USER_ANSIBLE : COLUMN_ORDER_USER;
};

export const getGroupPushCommits = (group: Run[]): string[] => {
  const headHash = group[0].commit.hash;

  return [...new Set([headHash, ...group.flatMap((run) => run.commits ?? [])])];
};
